import React from 'react'
import { connect } from 'react-redux'

import ImageEditModal from '../image-edit/ImageEditModal'
import { addGalleryImage } from '../../../actions/portal'

class ImageListImageEditModal extends React.Component {
  handleUpload = ({ ref, currentImageId, onClose }) => {
    if (currentImageId) {
      this.props.onReloadImage()
    } else {
      this.props.addGalleryImage(ref)
    }
    onClose()
  }

  render() {
    return <ImageEditModal {...this.props} handleUpload={this.handleUpload} />
  }
}

export default connect(null, { addGalleryImage })(ImageListImageEditModal)



// WEBPACK FOOTER //
// ./src/components/templates/image-list/ImageListImageEditModal.js